<app-loading-generico [loadingGenerico]="loadingGenerico"></app-loading-generico>
<app-header></app-header>
<app-botao-chat></app-botao-chat>
<app-alert-erro [alertErro]="alertErro" [mensagemErro]="mensagemErro" (alertErroFechou)="eventoAlertErroFechou($event)">
</app-alert-erro>
<app-confirma-exclusao [confirmaExclusao]="alertConfirmacao" (confirmaExclusaoFechou)="fecharAlertConfirmacao($event)">
</app-confirma-exclusao>
<app-alert-sucesso [alertSucesso]="showAlertSucesso" [alertSucessoSubtitulo]="mensagemSucesso" (alertSucessoFechou)="fechouRotaEmLote()"></app-alert-sucesso>
<app-alert-generico
  [message]="roteirizacaoEmLote.message"
  [buttons]="roteirizacaoEmLote.buttons"
  [show]="showAlertRoteirizacao"
  [description]="roteirizacaoEmLote.description">
</app-alert-generico>
<app-alert-erro-customizado [alertErro]="erroListaUsuarios" [alertErroMensagem]="mensagemErroListaUsuarios" [alertErroTitulo]="tituloMensagemErroListaUsuarios" [alertErroBotao]="botaoErroListaUsuarios" (alertErroFechou)="fecharAlertListaUsuariosError()"></app-alert-erro-customizado>

<div class="container py-4">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <app-breadcrumb></app-breadcrumb>
        <h1 class="titulo">Usuários de benefícios</h1>
        <p class="paragrafo mb-4">Cadastro de usuários que utilizam benefícios na empresa</p>

        @if (usuarios !== false && usuarios !== null) {
          <div class="container-us-beneficio">
            <div class="col-6 col-lg-4">
              <div class="mb-4">
                <span class="texto-titulo">FILTRO</span>
                <!--  -->
                <div class="mt-2">
                  <input type="text" class="form-control" id="inptFiltroUsuarioBeneficio" [(ngModel)]="searchTextFilter" (keyup)="searchUserFilter()"  (ngModelChange)="formatSearchText()"
                    placeholder="Digite algo" autoComplete="off">
                  @if (searchTextFilterUsers) {
                    <ul class="list-group lista-usuarios-ul">
                      @for (user of searchTextFilterUsers; track user) {
                        <li class="list-group-item" style="width: 325px;">
                          <button class="btn-icon ms-4" (click)="closeSearchTextFilter(user)">
                            {{ user.nomeUsuario }}
                          </button>
                        </li>
                      }
                    </ul>
                  }
                  @if (usuarioEncontrado === false) {
                    <p class="legenda-erro">Nenhum usuário foi encontrado!</p>
                  }
                </div>
              </div>
            </div>
            <div class="pt-5">
              <i
                class="fa fa-info-circle c-black fa-1x mb-4 icone-padrao"
                aria-hidden="true"
                [popover]="myPopoverFiltro"
                popoverTitle="Filtro de usuários"
                popoverPlacement="top"
                triggers="click"
                [outsideClick]="true">
              </i>
              <ng-template #myPopoverFiltro>
                <span class="texto-tabela">
                  Escolha o tipo de ordenação para os usuários.
                </span>
              </ng-template>
            </div>
            <div class="col-6 col-lg-4">
              <div class="mb-4">
                <label class="texto-titulo" for="slctSituacao">SITUAÇÃO</label>
                <div class="mb-3">
                  <app-select
                    [value]="status"
                    (valueChanges)="status = $event"
                    name="statusnAME"
                    id="slctSituacao"
                [options]="[
                {name : 'Ativos' , value : 'S'} ,
                {name : 'Inativos' , value : 'N'} ,
                {name : 'Todos' , value : 'T'}

                ]"
                    optionValue="value"
                    optionText="name">
                  </app-select>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg">
              <div class="mt-2">
                <br>
                  <button type="button" class="botao mb-4 ms-0 me-3" id="btnFiltrar" (click)="filtrar()"> FILTRAR</button>
                  @if (searchTextFilter || status != 'S') {
                    <button type="button" class="botao-outline mb-4 ms-0" id="btnLimparFiltro"
                    (click)="limparFiltro()"> LIMPAR FILTRO</button>
                  }
                </div>
              </div>
            </div>
          }

          @if (usuariosBeneficios?.length > 0) {
            <table class="table table-hover border-bottom mt-4">
              <caption>Tabela com lista de usuários de benefícios</caption>
              <thead>
                <tr>
                  <th scope="col">
                    <div class="form-check">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        id="selecionaTodosPedidos"
                        [checked]="isTodosSelecionados"
                        (change)="selecionaTodos($event.target)"
                        (keydown)="selecionaTodos($event.target)"
                        aria-label="selecionaTodosPedidos"
                        >
                      <label class="form-check-label" for="selecionaTodosPedidos"></label>
                    </div>
                  </th>
                  <th scope="col">MATRÍCULA</th>
                  <th scope="col">NOME DO USUÁRIO</th>
                  <th scope="col">CPF</th>
                  <th scope="col">SITUAÇÃO</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                @for (usuario of usuariosBeneficios; track usuario; let iUsuario = $index) {
                  <tr>
                    <td>
                      <div class="form-check">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          id="checkbox{{ iUsuario + 1 }}"
                          [checked]="usuario.checked"
                          (change)="checkboxTableClick(usuario)"
                          (keydown)="checkboxTableClick(usuario)"
                          [attr.aria-label]="'checkbox' + (iUsuario + 1)"
                          >
                        <label class="form-check-label" for="checkbox{{ iUsuario + 1 }}"></label>
                      </div>
                    </td>
                    <td>{{usuario.codigoUsuario}}</td>
                    <td>{{usuario.nomeUsuario}}</td>
                    <td>{{usuario.codigoCpf | cpf}}</td>
                    @if (usuario.flagAtivo == 'S') {
                      <td class="status-ativo">Ativo</td>
                    }
                    @if (usuario.flagAtivo == 'N') {
                      <td class="status-inativo">Inativo</td>
                    }
                    <td class="text-center">
                      <span title="A edição só é permitida após o processamento do pedido em andamento">
                        <button class="btn pt-0" id="btnEditarUsuario" (click)="editarUsuario(usuario)"
                  [disabled]="(!('CadastrosUsuariosDeBeneficio' | usuarioPermissao:'Alterar' | async)
                    && !('UsuariosDeBeneficioSolicitacao2aVia' | usuarioPermissao:'Alterar' | async))  || pedidoAtivoFinalizado == false">
                          <i class="fa fa-pencil c-primary" aria-hidden="true"></i>
                        </button>
                      </span>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          }

          @if (usuarios === null || usuarios === false || usuarios === undefined) {
            <app-api-state
              [state]="usuarios"
              loadingText="Consultando usuários ..."
              errorText="Ocorreu um erro na consulta dos usuários de benefícios."
              emptyText="Não foi possível encontrar o usuário selecionado.">
            </app-api-state>
          }

          @if (usuarios !== false && usuarios !== null) {
            <div class="container mt-4">
              <div class="row">
                <div class="col-lg-12 text-center">
                  <button type="button" class="botao-outline ms-2" id="btnSugestaoRotaEmLote" (click)="confirmarRotaEmLote()"
                  >SUGESTÃO DE ROTA EM LOTE</button>
                  <button type="button" class="botao-outline ms-2" id="btnIncluir"
                    [ngClass]="{disabled: !('CadastrosUsuariosDeBeneficio' | usuarioPermissao:'Incluir' | async) || pedidoAtivoFinalizado == false}"
                    [disabled]="!('CadastrosUsuariosDeBeneficio' | usuarioPermissao:'Incluir' | async)"
                  [routerLink]="['/dados-usuario']">INCLUIR</button>
                  <button type="button" class="botao-outline ms-2" id="btnAtivar"
                    [ngClass]="{'disabled': !checkedUsersId.length || !('CadastrosUsuariosDeBeneficio' | usuarioPermissao:'Alterar' | async)}"
                    [disabled]="!checkedUsersId.length || !('CadastrosUsuariosDeBeneficio' | usuarioPermissao:'Alterar' | async)"
                  (click)="activeUsers()">ATIVAR</button>
                  <button type="button" class="botao-outline ms-2" id="btnDesativar"
                    [ngClass]="{'disabled': !checkedUsersId.length || !('CadastrosUsuariosDeBeneficio' | usuarioPermissao:'Alterar' | async)}"
                    [disabled]="!checkedUsersId.length || !('CadastrosUsuariosDeBeneficio' | usuarioPermissao:'Alterar' | async)"
                  (click)="desactiveUsers()">DESATIVAR</button>
                  <button type="button" class="botao-erro-outline ms-2" id="btnExcluirSelecionados"
                    [ngClass]="{'disabled': !checkedUsersId.length || !('CadastrosUsuariosDeBeneficio' | usuarioPermissao:'Excluir' | async) || pedidoAtivoFinalizado == false}"
                    [disabled]="!checkedUsersId.length || !('CadastrosUsuariosDeBeneficio' | usuarioPermissao:'Excluir' | async)"
                  (click)="confirmarExclusaoContato()">EXCLUIR SELECIONADOS</button>
                  <button class="botao-outline ms-2"
                    [disabled]="!hasSelectedUsers()"
                  (click)="fazerPedidoAvulso()">PEDIDO AVULSO</button>
                </div>
              </div>
            </div>
          }

          <!-- FOOTER-CARD - PAGINAÇÃO -->
          @if (usuarios) {
            <div class="footer-card">
              <div class="container-select">
                <app-select
                  (change)="alteraQuantidadePorPagina()"
                  [value]="tamanho"
                  (valueChanges)="tamanho = $event"
                  name="tamanhoName"
            [options]="[
            {name : 'Exibir 3 por página' , value : '3'} ,
            {name : 'Exibir 6 por página' , value : '6'} ,
            {name : 'Exibir 9 por página' , value : '9'}

            ]"
                  optionValue="value"
                  optionText="name">
                </app-select>
              </div>
              <!-- Paginação CENTRAL -->
              <div class="py-0 px-2">
                @for (item of itensPaginacao; track item) {
                  <button
                    class="itens-pagina btn-icon"
                    [ngClass]="{ 'item-ativo': pagina == item.valor }"
                    (click)="alteraPagina(item.valor)"
                    >
                    {{ item.pagina }}
                  </button>
                }
              </div>
              <div class="container-registros">
                @if (usuarios.pageRequest.total == 1) {
                  <p><span
                  class="itens-pagina me-0">{{usuarios.pageRequest.total}}</span> registro foi encontrado</p>
                }
                @if (usuarios.pageRequest.total != 1) {
                  <p><span
                  class="itens-pagina me-0">{{usuarios.pageRequest.total}}</span> registros foram encontrados</p>
                }
              </div>
            </div>
          }

        </div>
      </div>
    </div>
  </div>

  <app-footer></app-footer>
